module.exports = __webpack_public_path__ + "assets/img/zhanghu.834967ce.png";